import { render, staticRenderFns } from "./SlipDock.vue?vue&type=template&id=7a1b4c9e&scoped=true"
import script from "./SlipDock.vue?vue&type=script&lang=js"
export * from "./SlipDock.vue?vue&type=script&lang=js"
import style0 from "./SlipDock.vue?vue&type=style&index=0&id=7a1b4c9e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a1b4c9e",
  null
  
)

export default component.exports